import React, { useState } from 'react';
import './AddRecipe.css';
import { toast } from 'react-toastify';
import { useAdminContext } from '../../../context/AdminContext';

const AddRecipe = ({ onClose, onSuccess }) => {
  const { addRecipe } = useAdminContext();

  const [title, setTitle] = useState('');
  const [short, setShort] = useState('');
  const [imageLink, setImageLink] = useState('');
  const [imageBase64, setImageBase64] = useState('');
  const [steps, setSteps] = useState(['']);
  const [ingredients, setIngredients] = useState(['']);
  const [nutrition, setNutrition] = useState({
    calories: '', protein: '', fats: '', carbs: ''
  });
  const [type, setType] = useState('');

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setImageBase64(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!title || !short || (!imageBase64 && !imageLink)) {
      toast.error('Title, description, and image are required.');
      return;
    }

    const recipe = {
      title,
      short,
      image: imageBase64 || imageLink,
      steps: steps.filter(Boolean),
      ingredients: ingredients.filter(Boolean),
      nutritionalValues: {
        calories: parseInt(nutrition.calories || 0),
        protein: parseInt(nutrition.protein || 0),
        fats: parseInt(nutrition.fats || 0),
        carbs: parseInt(nutrition.carbs || 0),
      },
      ...(type && { type }),
      createdAt: new Date(),
    };

    try {
      await addRecipe(recipe);
      toast.success('Recipe added!');
      onSuccess && onSuccess();
      onClose && onClose();
    } catch (err) {
      toast.error('Failed to add recipe.');
    }
  };

  return (
    <div className="add-recipe">
      <div className="close" onClick={onClose}>X</div>
      <form onSubmit={handleSubmit} className="recipe-form">
        <h2>Add Recipe</h2>

        <input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Recipe Title" required />
        <textarea value={short} onChange={(e) => setShort(e.target.value)} placeholder="Short Description" required />

        <label>Image Upload</label>
        <input type="file" accept="image/*" onChange={handleImageChange} />
        <input type="url" value={imageLink} onChange={(e) => setImageLink(e.target.value)} placeholder="Or Image URL" />

        <label>Steps</label>
        {steps.map((s, i) => (
          <div key={i} style={{ display: 'flex', gap: '0.5rem', marginBottom: '0.5rem' }}>
            <input
              value={s}
              onChange={(e) => {
                const newSteps = [...steps];
                newSteps[i] = e.target.value;
                setSteps(newSteps);
              }}
              placeholder={`Step ${i + 1}`}
              style={{ flex: 1 }}
            />
            {steps.length > 1 && (
              <button
                type="button"
                onClick={() => setSteps(steps.filter((_, idx) => idx !== i))}
                style={{ background: '#dc3545', color: '#fff', border: 'none', padding: '0 0.7rem', borderRadius: '4px' }}
              >
                X
              </button>
            )}
          </div>
        ))}
        <button type="button" onClick={() => setSteps([...steps, ''])}>+ Add Step</button>

        <label>Ingredients</label>
        {ingredients.map((ing, i) => (
          <div key={i} style={{ display: 'flex', gap: '0.5rem', marginBottom: '0.5rem' }}>
            <input
              value={ing}
              onChange={(e) => {
                const newIngs = [...ingredients];
                newIngs[i] = e.target.value;
                setIngredients(newIngs);
              }}
              placeholder={`Ingredient ${i + 1}`}
              style={{ flex: 1 }}
            />
            {ingredients.length > 1 && (
              <button
                type="button"
                onClick={() => setIngredients(ingredients.filter((_, idx) => idx !== i))}
                style={{ background: '#dc3545', color: '#fff', border: 'none', padding: '0 0.7rem', borderRadius: '4px' }}
              >
                X
              </button>
            )}
          </div>
        ))}
        <button type="button" onClick={() => setIngredients([...ingredients, ''])}>+ Add Ingredient</button>

        <label>Nutritional Info</label>
        <input type="number" placeholder="Calories" value={nutrition.calories} onChange={(e) => setNutrition({ ...nutrition, calories: e.target.value })} />
        <input type="number" placeholder="Protein (g)" value={nutrition.protein} onChange={(e) => setNutrition({ ...nutrition, protein: e.target.value })} />
        <input type="number" placeholder="Fats (g)" value={nutrition.fats} onChange={(e) => setNutrition({ ...nutrition, fats: e.target.value })} />
        <input type="number" placeholder="Carbs (g)" value={nutrition.carbs} onChange={(e) => setNutrition({ ...nutrition, carbs: e.target.value })} />

        <input type="text" placeholder="Type (e.g., trending)" value={type} onChange={(e) => setType(e.target.value)} />

        <button type="submit" className="submit-btn">Add Recipe</button>
      </form>
    </div>
  );
};

export default AddRecipe;
